import(/* webpackMode: "eager" */ "/codebuild/output/src1053796749/src/doctor-dashboard/app/global-error.tsx");
